import { render, staticRenderFns } from "./ks-index.vue?vue&type=template&id=1f43cf9d"
import script from "./ks-index.vue?vue&type=script&lang=js"
export * from "./ks-index.vue?vue&type=script&lang=js"
import style0 from "./ks-index.vue?vue&type=style&index=0&id=1f43cf9d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports